import {
  SET_ERROR,
  SET_LOADING,
  SET_ATTRIBUTES,
  SET_ATTRIBUTES_DELETE
} from "@/store/constants/mutation-types";
import {
  MESSAGE_SUCCESS_DELETE_ATTRIBUTE,
  MESSAGE_SUCCESS_ATTRIBUTE,
  MESSAGE_SUCCESS_EDIT_ATTRIBUTE
} from "@/store/constants/messages";

const state = {
  attributs: [],
  totalItems: 0
};

const getters = {
  /**
   * @description retourn attributesItem
   * @returns {boolean}
   */
  getAttributes: () => state.attributs,

  /**
   * @description retourn totalItems
   * @returns length
   */
  getTotalItems: () => state.totalItems
};

const mutations = {
  /**
   * @description mutation message success
   * @param state
   * @param successMessage
   */
  [SET_ATTRIBUTES](state, attributesItem) {
    state.attributs = attributesItem["hydra:member"];
    state.totalItems = attributesItem["hydra:totalItems"];
  },

  /**
   * @description mutation delete attributs
   * @param state
   * @param index
   */
  [SET_ATTRIBUTES_DELETE](state, index) {
    state.attributs.splice(index, 1);
  }
};

const actions = {
  /**
   * @description récupère les Attributes
   * @param commit
   * @param dispatch
   * @param categoryMirakl
   * @returns {Promise<void>}
   */
  async getList({ commit, dispatch }, page) {
    try {
      commit(SET_LOADING, true, { root: true });
      const { data } = await this._vm.$gwzApi
        .service("attributes")
        .listMiraklAttributes(page);

      commit(SET_ATTRIBUTES, data);
      commit(SET_LOADING, false, { root: true });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  },

  /**
   * @description Ajoute un label Mirakl
   * @param commit
   * @param dispatch
   * @param attributes
   * @returns {Promise<void>}
   */
  async addAttribute({ commit, dispatch }, attribute) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi.service("attributes").addAttribute(attribute);
      commit(SET_LOADING, false, { root: true });
      dispatch("setSuccessToast", MESSAGE_SUCCESS_ATTRIBUTE, { root: true });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  },

  /**
   * @description delete un attribut
   * @param commit
   * @param dispatch
   * @param id index
   * @returns {Promise<void>}
   */
  async deleteAttribut({ commit, dispatch }, { id, index }) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi.service("attributes").deletAttribute(id);
      dispatch("setSuccessToast", MESSAGE_SUCCESS_DELETE_ATTRIBUTE, {
        root: true
      });
      commit(SET_ATTRIBUTES_DELETE, index);
      commit(SET_LOADING, false, { root: true });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  },

  /**
   * @description Edite un label Mirakl
   * @param commit
   * @param dispatch
   */
  async editAttribute({ commit, dispatch }, { id, form }) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi.service("attributes").editAttribute(id, form);
      commit(SET_LOADING, false, { root: true });
      dispatch("setSuccessToast", MESSAGE_SUCCESS_EDIT_ATTRIBUTE, {
        root: true
      });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
